'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargeShare = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.107 3.41241C12.5386 3.2106 13.0393 3.28714 13.3924 3.58756L13.3945 3.58929L21.2878 10.3559C21.579 10.6054 21.7 10.958 21.7 11.2728C21.7 11.5878 21.5792 11.9396 21.2892 12.1893L13.3945 18.957L13.3924 18.9588C13.0366 19.2615 12.5358 19.3331 12.1078 19.1343L12.1063 19.1336C11.6811 18.9349 11.4103 18.5088 11.4103 18.0399V15.6226C9.87969 15.8983 7.18467 16.9487 5.74181 20.9073L5.08413 20.6676L5.74242 20.9056C5.5544 21.4256 5.0379 21.749 4.48973 21.6933L4.4865 21.693C3.93869 21.6347 3.50293 21.2119 3.42231 20.6706L3.42171 20.6665C3.40702 20.5637 3.30005 19.7956 3.30005 18.6694C3.30005 16.636 3.64699 13.2953 5.65703 10.6566C7.0513 8.82667 8.99963 7.66546 11.4103 7.17538V4.50639C11.4103 4.03869 11.6793 3.61098 12.107 3.41241ZM4.42585 20.4295L4.42646 20.4279L4.42585 20.4295Z",
            fill: "currentColor"
        }) : jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.08408 20.6676C6.93654 15.5852 10.7677 14.9111 12.1102 14.8353V18.0399C12.1102 18.2371 12.2239 18.4159 12.4026 18.4994C12.5804 18.582 12.7892 18.5528 12.9388 18.4256L20.8324 11.6588C21.0559 11.4665 21.0559 11.0789 20.8324 10.8875L12.9388 4.12074C12.7892 3.99348 12.5804 3.96337 12.4026 4.04691C12.2239 4.12948 12.1102 4.30822 12.1102 4.50638V7.76155C9.57973 8.15011 7.5971 9.26527 6.21382 11.0808C4.34388 13.5356 4 16.6868 4 18.6694C4 19.7525 4.10297 20.4859 4.11463 20.5675C4.14862 20.7958 4.33222 20.9726 4.5605 20.9969C4.78975 21.0202 5.0054 20.8852 5.08408 20.6676Z",
            stroke: "currentColor",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

module.exports = LargeShare;
